export default "__VITE_ASSET__CTSnZC$n__"